import React from "react";
import styled from "styled-components";
import Drawer from "../../UI/Drawer/Drawer";
import Icon from "../../Icon/Icon";
import { invert } from "polished";
import { NavLink } from "react-router-dom";
import { MenuItem } from "../../../../typings/typings";


const MobileMenuUl = styled.ul`
    list-style: none;
    color: white;
    &.active{
        > li:not(.second-level-active){
            opacity: 0;
        }
        .second-level-active > button {
            opacity: 0;
        }
    }
    div{
        background: transparent;
    }
`;
const MobileMenuLi = styled.li`
    border: none;
    display: list-item;
    text-transform: uppercase;
    a, button{
        text-transform: uppercase;
        color: inherit;
    }
    &, button{
        transition: all .3s linear;
    }


    &.menu-header{
        position: relative;
    }
    .btn-login{
        min-width: 80px;
        font-size: 0.7333rem;
        top: -2px;
        position: relative;
        display: none;
    }

    .menu-item-btn
    {
        padding-left: 1.5rem;
    }

    > div{
        transform: translateX(100%);
        top: 60px;
    }

    &.second-level-active{
        > div{
            transform: translateX(0%);
            visibility: visible;
        }
        ul > li > div{
            top: 0;
            overflow: auto;
            max-height: calc(100vh - 60px);
            padding-bottom: 60px;
        }
        .menu-header button{
            font-size: 0.7333rem;
        }
        &.third-level-active{
            ul {
                .mobile-header{
                    opacity: .5;
                }
            }
            ul > li.third-level > div{

                transform: translateX(0%);
                visibility: unset;
            }

            button{
                opacity: 0;
                & + div {
                    button{
                        opacity: 0;
                    }
                    li:not(.third-level){
                        .menu-header, a{
                            opacity: 0;
                        }
                    }
                    li.third-level{
                        button{
                            opacity: 0;
                        }
                        > div button{
                            opacity: 1;

                        }
                        a{
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
`;

const MenuHeaderLi = styled(MobileMenuLi)`
    margin-bottom: .5rem;
    display: flex;
    flex-flow: row nowrap;

    .menu-header-btn {
        display: block;
        padding-left: 1.5rem;
        padding-right: 2rem;
        flex: 1;
    }
    .menu-header-link {
        padding: .75rem 1rem;
        padding-bottom: 0.9rem;
        display: flex;
        flex: 0 auto;
        align-items: center;
        font-weight: 600;
        font-size: 0.7rem;
        letter-spacing: 2px;
        width: 100%;
    }

    .second-level-active &,
    .third-level-active & {
        margin-bottom: 0;
    }
`;

const ImageMenu = styled.div`
    height: 100%;
    position: relative;
    z-index: 101;
    color: white;
    + .images{
        background: black;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100vh;
        box-sizing: border-box;
        z-index: 0;
        > div{
            background-size: cover;
            background-position: center;
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 100%;
            box-sizing: border-box;
            transition: opacity .5s linear;
            top: 0;
        }
    }
`;


interface MobileMenuProps
{
    show: boolean;
    closeDrawer: () => void;
    color?: string;
    setColor?: (color: string) => void;
    menuItems: Array<MenuItem>;
    menuItemOnClick: (menuItem: MenuItem) => void;
}

const MobileMenu: React.FC<MobileMenuProps> = (props) =>
{
    const [activeMenu, setMenu] = React.useState(-1);
    const [activeSubMenu, setSubMenu] = React.useState(-1);

    const gotoItem = (e: number, color: string | undefined) => (evt: React.SyntheticEvent) =>
    {
        setMenu(e);
        if (color && props.setColor)
        {
            props.setColor(color);
        }
    };

    const gotoSubItem = (e: number) => (evt: React.SyntheticEvent) =>
    {
        setSubMenu(e);
    };

    const handledNavClick = (menuItem: MenuItem) => () =>
    {
        props.menuItemOnClick(menuItem);
    };

    const getThirdMenu = (item: MenuItem, itemColor: string | undefined, zIndex: number) =>
    {
        return (
            <Drawer placement="left" styleType="full" zIndex={zIndex}>
                <MobileMenuUl style={{ color: itemColor ?? "" }}>
                    <MenuHeaderLi className="menu-header">
                        <button className="menu-header-btn" onClick={gotoSubItem(-1)}>
                            <Icon name="arrow-left-line" className="w-4 h-4" />
                        </button>
                        <NavLink className="menu-header-link" to={item.url} onClick={handledNavClick(item)}><span>{item.name}</span></NavLink>
                    </MenuHeaderLi>
                    {item.children ? item.children.map((thirditem, thirdindex) => (
                        <MobileMenuLi key={thirdindex}>
                            <NavLink className="menu-item-btn" to={thirditem.url} onClick={handledNavClick(thirditem)}>{thirditem.name}</NavLink>
                        </MobileMenuLi>)) : null}
                </MobileMenuUl>
            </Drawer>
        );
    };

    const getSecondMenu = (item: MenuItem, itemIndex: number, zIndex: number) =>
    {
        return <Drawer placement="left" styleType="full" zIndex={zIndex}>
            <MobileMenuUl style={{ color: activeMenu === itemIndex ? item.dropdownColor : "inherit" }}>
                {item.children && item.children.length > 0 ?
                    <MenuHeaderLi className="menu-header">
                        <button className="menu-header-btn" onClick={gotoItem(-1, "#fff")}>
                            <Icon name="arrow-left-line" className="w-4 h-4" />
                        </button>
                        <NavLink className="menu-header-link" to={item.url} onClick={handledNavClick(item)}><span>{item.name}</span></NavLink>
                    </MenuHeaderLi> : null}
                {item.children && item.children.map((seconditem, subindex) =>
                {
                    return (
                        <MobileMenuLi key={subindex} className={activeSubMenu === subindex ? "third-level" : ""} >
                            {seconditem.children && seconditem.children.length > 0 ?
                                (
                                    <button className="menu-item-btn" onClick={gotoSubItem(subindex)}>
                                        {seconditem.name} {/*<Icon name="arrow-right" className="ml-4 w-3 h-3" />*/}
                                    </button>
                                ) : (
                                    <NavLink className="menu-item-btn" to={seconditem.url} onClick={handledNavClick(seconditem)}>{seconditem.name}</NavLink>
                                )}
                            {seconditem.children && seconditem.children.length > 0 ? getThirdMenu(seconditem, item.dropdownColor, zIndex + 1) : null}
                        </MobileMenuLi>
                    );
                })}

            </MobileMenuUl>
        </Drawer>;
    };

    const getBackgroundImage = (menuItem: MenuItem) =>
    {
        if (menuItem && menuItem.children && menuItem.children.length > 0)
        {
            const backgroundImage = menuItem.children[0]?.dropdownBackgroundImage;
            if (backgroundImage)
            {
                const url = typeof backgroundImage !== "string" ? backgroundImage.umbracoFile?.src : backgroundImage;
                return `url(${url})`;
            }
        }
        return "";
    };

    const getMenu = (zIndex: number) =>
    {
        return (
            props.menuItems.map((x, index) =>
                <MobileMenuLi key={index}
                    className={`${activeMenu === index ? "second-level-active" : ""} ${activeMenu === index && activeSubMenu !== -1 ? "third-level-active" : ""} ${index === 0 ? "menu-item-login" : ""}`}
                >
                    {x.children && x.children.length > 0 ? (
                        <button className="menu-item-btn" onClick={gotoItem(index, x.dropdownColor)}>{x.name}</button>
                    ) : (
                        <NavLink className="menu-item-btn" to={x.url} onClick={handledNavClick(x)}>{x.name}</NavLink>
                    )}
                    {x.children && x.children.length > 0 ? getSecondMenu(x, index, zIndex + 1) : null}
                </MobileMenuLi>
            )
        );
    };

    return <Drawer visible={props.show} close={props.closeDrawer} placement="left" styleType="full" zIndex={99}>
        <ImageMenu>
            <MobileMenuUl className={`${activeMenu !== -1 ? "active" : ""}`}>
                <MenuHeaderLi className="menu-header">
                    <button className="menu-header-btn" onClick={() => props.closeDrawer()}></button>
                </MenuHeaderLi>
                {getMenu(99 + 1)}
            </MobileMenuUl>
        </ImageMenu>
        <div className="images">
            {props.menuItems ? props.menuItems.map((x, index) =>
            {
                return <div key={"background" + index} style={{
                    backgroundImage: getBackgroundImage(x),
                    opacity: activeMenu === index || (activeMenu === -1 && index === 0) ? 1 : 0,
                    backgroundColor: x.dropdownColor ? invert(x.dropdownColor) : ""
                }}></div>;
            }
            ) : null}
        </div>
    </Drawer>;
};

export default MobileMenu;
